import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";

import { loadRestaurantSummaryAsync } from "../../../../actions/restaurantDetails";
import { Line } from "react-chartjs-2";

export class RestaurantSummary extends React.Component {
  componentDidMount() {
    this.props.loadRestaurantSummaryAsync({
      id: this.props.id,
    });
  }

  render() {
    let graphData = this.props.graphData || [];
    let datetimes = graphData.map((a) => a.dateTime) || [];
    let minutes = graphData.map((a) => a.minutes) || [];

    const data = {
      labels: datetimes,
      datasets: [
        {
          label: "Best guess value (minutes) Time in UTC",
          data: minutes,
          borderColor: "rgb(75, 192, 192)",
          fill: "false",
          borderWidth: 2,
        },
      ],
    };

    const options = {
      scales: {
        yAxes: [
          {
            ticks: {
              suggestedMin: 0,
              suggestedMax: 100,
            },
          },
        ],
      },
    };

    return (
      <div className="row">
        <div className="col-md-3">
          <table className="table">
            <tbody>
              <tr>
                <th scope="row">PoolId</th>
                <td>{this.props.id}</td>
              </tr>
              <tr>
                <th scope="row">Events count</th>
                <td>{this.props.eventCount}</td>
              </tr>
              <tr>
                <th scope="row">Best guess received</th>
                <td>{this.props.bestGuessReceived}</td>
              </tr>
              <tr>
                <th scope="row">Best guess</th>
                <td>{this.props.bestGuess}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="col-md-9">
          <Line data={data} options={options} />
        </div>
      </div>
    );
  }
}

RestaurantSummary.propTypes = {
  id: PropTypes.string.isRequired,
  bestGuessReceived: PropTypes.string,
  bestGuess: PropTypes.string,
  graphData: PropTypes.array,
  loadRestaurantSummaryAsync: PropTypes.func,
  eventCount: PropTypes.number,
};

const mapStateToProps = (state, props) => {
  let newState = state.restaurantDetails.summary;
  return {
    ...props,
    eventCount: newState.eventCount,
    bestGuessReceived: newState.bestGuessReceived,
    bestGuess: newState.bestGuess,
    graphData: newState.graphData,
  };
};

const mapDispatchToProps = (dispatch) => bindActionCreators({ loadRestaurantSummaryAsync }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(RestaurantSummary);



// WEBPACK FOOTER //
// ./src/containers/restaurants/details/summary/index.js